import React, { Component, useRef, useState } from "react";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";

import Breadcrumb from "../../common/breadcrumb";
import { postCall, getCall } from "../../../api/post";
import {
  saveUserDetailsToLocalStorage,
  loadUserDetailsFromLocalStorage,
  getValueFromLanguageObject,
  getColorCodeBasedOnKey,
  isStoreOpen,
} from "../../../store/index";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { connect } from "react-redux";
import {
  getMerchantInformationUrl,
  getMasterDetailsIdUrl,
  getTenantInfoUrl,
} from "../../../services";
import { Helmet } from "react-helmet";
import MainLoader from "../../../animation/MainLoader";
import ErrorMessageAnimationModal from "../../../animation/ErrorMessageAnimationModal";
import SuccessMessageAnimationModal from "../../../animation/SuccessMessageAnimationModal";
import { isUserAllowedToRegister } from "../../../actions";
import { clearLocalStorageReload, navigateTo } from "../../../utils/utils";
import { withRouter } from "react-router-dom";
import { Button } from "antd";
import { handlePostLoginRedirect } from "../../../utils/cartRedirect";

class Login extends Component {
  state = {
    agent_code: "",
    username: "",
    password: "",
    isLoading: false,
    showErrorMessageModal: false,
    errorMessage: "",
    showSuccessMessageModal: false,
    successMessage: "",
    AppTitle: "",
    showPassword: false, // Add this state
  };

  componentDidMount() {
    const userDetails = loadUserDetailsFromLocalStorage();
    if (userDetails !== undefined) {
      navigateTo(this.props, `/dashboard`);
      return;
    }
    this.initMasterDetailsId().then(() => {
      this.initMerchantInfo().then(() => {
        this.setState({ isLoading: false });
      });
      this.initTenantInfo();
    });
  }

  initMasterDetailsId = async () => {
    let masterDetailsObj = {};
    const publicUrl = window.location.pathname.split("/")[1];
    const masterDetailsIdUrl = getMasterDetailsIdUrl(publicUrl);
    const masterDetails = await getCall(masterDetailsIdUrl, []).then();
    if (masterDetails.error) {
      clearLocalStorageReload({ response: masterDetails });
    } else {
      if (masterDetails) {
        masterDetailsObj = masterDetails;
      }
    }
    this.setState({ masterDetailsObj: masterDetailsObj });
  };

  initMerchantInfo = async () => {
    const { masterDetailsObj } = this.state;
    const merchantInfoUrl = getMerchantInformationUrl(masterDetailsObj);
    const merchantInfo = await getCall(merchantInfoUrl, []);
    if (merchantInfo.error) {
      clearLocalStorageReload({ response: merchantInfo });
      this.setState({
        AppTitle: "",
      });
    } else {
      this.setState({
        AppTitle: merchantInfo.companyname,
      });
    }
  };

  initTenantInfo = async () => {
    const { masterDetailsObj } = this.state;
    const { id } = masterDetailsObj || {};
    if (!id) {
      return;
    }
    this.setState({ isLoading: true });
    const tenantInfoUrl = getTenantInfoUrl(id);
    const tenantInfo = await getCall(tenantInfoUrl, []);
    this.setState({ isLoading: false });
    if (tenantInfo.error) {
      clearLocalStorageReload({ response: tenantInfo });
      this.loadErrorMessageAnimation(tenantInfo.error.message);
    } else {
      if (
        tenantInfo &&
        tenantInfo.length > 0 &&
        tenantInfo[0].text &&
        tenantInfo[0].text.length > 0
      ) {
        const tenantSettings = JSON.parse(tenantInfo[0].text);
        if ("isEmailBasedLogin" in tenantSettings) {
          this.setState({
            isEmailBasedLogin: tenantSettings.isEmailBasedLogin,
          });
        }
        if ("maxCellnumberDigitLimit" in tenantSettings) {
          this.setState({
            maxCellnumberDigitLimit: tenantSettings.maxCellnumberDigitLimit,
          });
        } else {
          this.setState({
            maxCellnumberDigitLimit: "10",
          });
        }
        if ("isShowXEModule" in tenantSettings) {
          this.setState({
            isShowXEModule: tenantSettings.isShowXEModule,
          });
        } else {
          this.setState({
            isShowXEModule: false,
          });
        }
      }
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  };

  onClickOfLogin = async (e) => {
    e.preventDefault();
    const { agent_code, username, password } = this.state;
    if (!agent_code || !username || !password) {
      this.loadErrorMessageAnimation("Please fill all fields");
      return;
    }
    this.setState({ isLoading: true });
    try {
      const response = await postCall("v2/auth/login", {
        agent_code,
        username,
        password,
      });
      this.setState({ isLoading: false });

      // Handle inactive user response
      if (
        response.responseStatus === 403 &&
        response.responseMessageCode === "AUTH_USER_INACTIVE" &&
        response.responseData &&
        response.responseData.message
      ) {
        this.loadErrorMessageAnimation(response.responseData.message);
        return;
      }

      if (
        response.detail &&
        response.detail.responseStatus === 401 &&
        response.detail.responseData &&
        response.detail.responseData.message
      ) {
        this.loadErrorMessageAnimation(response.detail.responseData.message);
        return;
      }
      if (response.error) {
        this.loadErrorMessageAnimation(response.error.message);
        return;
      }
      if (response.apitoken) {
        localStorage.removeItem("isStoreOpen");
        localStorage.removeItem("openStoreId");
        localStorage.setItem("apiToken", response.apitoken);
        saveUserDetailsToLocalStorage(response);

        // Redirect logic (same as after OTP verification)
        const { isFromCheckout, isFromDashboard, isFromCart } =
          this.props.match.params || {};
        const { isFromCollection } = this.props.match.params || {};

        if (isFromCart === "true") {
          handlePostLoginRedirect(this.props);
          return;
        }
        const postLoginRedirect = localStorage.getItem("postLoginRedirect");
        if (postLoginRedirect) {
          localStorage.removeItem("postLoginRedirect");
          navigateTo(this.props, postLoginRedirect);
          return;
        }
        if (this.state.isShowXEModule) {
          window.location.reload();
          this.props.history.push("/dashboard");
        } else if (isFromCheckout === "true") {
          this.props.history.push("/checkout");
          window.location.reload();
        } else if (isFromDashboard) {
          this.props.history.push("/");
          window.location.reload();
        } else {
          const { path, params } = this.props.match || {};
          const { id } = params || {};
          if (isFromCollection === "true") {
            this.props.history.push(`/collection/${id}`);
            window.location.reload();
          } else {
            this.props.history.push("/");
          }
        }
      } else {
        this.loadErrorMessageAnimation("Login failed. Please try again.");
      }
    } catch (err) {
      this.setState({ isLoading: false });
      this.loadErrorMessageAnimation("Login failed. Please try again.");
    }
  };

  loadErrorMessageAnimation = (message) => {
    this.setState({ errorMessage: message, showErrorMessageModal: true });
  };

  render() {
    const {
      agent_code,
      username,
      password,
      isLoading,
      AppTitle,
      showErrorMessageModal,
      errorMessage,
      showSuccessMessageModal,
      successMessage,
      showPassword, // Add this
    } = this.state;
    return (
      <div
        className="bg-light h-100"
        style={{ minHeight: "calc(100vh - 200px)" }}
      >
        <Helmet>
          <title>{AppTitle} | Login</title>
        </Helmet>
        <div className="container py-5">
          <div className="row flex-row-reverse align-items-center">
            <div className="col-12 col-md-6 col-lg-5">
              <div
                className="login-page w-100"
                style={{
                  maxWidth: "470px",
                }}
              >
                <div className="card">
                  <div className="card-body p-5">
                    <h3
                      style={{
                        marginBottom: "24px",
                        fontWeight: 600,
                        textAlign: "left",
                      }}
                    >
                      Login
                    </h3>
                    <form className="theme-form" onSubmit={this.onClickOfLogin}>
                      <div className="form-group">
                        {/* <label htmlFor="agent_code">Agent Code</label> */}
                        <input
                          id="agent_code"
                          name="agent_code"
                          type="text"
                          onChange={this.handleChange}
                          className="form-control"
                          value={agent_code}
                          placeholder="Enter Agent Code"
                          required
                        />
                      </div>
                      <div className="form-group">
                        {/* <label htmlFor="username">Username</label> */}
                        <input
                          id="username"
                          name="username"
                          type="text"
                          onChange={this.handleChange}
                          className="form-control"
                          value={username}
                          placeholder="Enter Username"
                          required
                        />
                      </div>
                      <div
                        className="form-group"
                        style={{ position: "relative" }}
                      >
                        {/* <label htmlFor="password">Password</label> */}
                        <input
                          id="password"
                          name="password"
                          type={showPassword ? "text" : "password"}
                          onChange={this.handleChange}
                          className="form-control"
                          value={password}
                          placeholder="Enter Password"
                          required
                          style={{ paddingRight: "40px" }}
                        />
                        <span
                          onClick={this.togglePasswordVisibility}
                          style={{
                            position: "absolute",
                            right: "12px",
                            top: "10px",
                            cursor: "pointer",
                            fontSize: "20px",
                            color: "#888",
                          }}
                        >
                          {showPassword ? (
                            <EyeInvisibleOutlined />
                          ) : (
                            <EyeOutlined />
                          )}
                        </span>
                      </div>
                      <Button
                        htmlType="submit"
                        className="btn btn-solid"
                        loading={isLoading}
                        style={{
                          width: "100%",
                          marginTop: "16px",
                          height: "44px", // Increase button height
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center", // Center text
                          fontWeight: 600,
                          fontSize: "16px",
                        }}
                      >
                        Login
                      </Button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-7">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/login-img.svg`}
                alt="reward-img"
                className="img-fluid"
              />
            </div>
          </div>
        </div>

        {isLoading && <MainLoader />}
        {showErrorMessageModal && (
          <ErrorMessageAnimationModal
            show={showErrorMessageModal}
            message={errorMessage}
            onClose={() => {
              this.setState({ showErrorMessageModal: false });
            }}
          />
        )}
        {showSuccessMessageModal && (
          <SuccessMessageAnimationModal
            show={showSuccessMessageModal}
            message={successMessage}
            onClose={() => {
              this.setState({ showSuccessMessageModal: false });
            }}
          />
        )}
      </div>
    );
  }
}

export default withRouter(Login);
